export default () => ({
    init() {
      this.$nextTick(() => {
        this.scrollActiveTagIntoView();
      });
    },
  
    scrollActiveTagIntoView() {
      const activeTag = this.$el.querySelector('[data-active-tag="true"]');
  
      if (!activeTag) return;
  
      window.requestAnimationFrame(() => {
        const targetScrollLeft =
          activeTag.offsetLeft - (this.$el.clientWidth - activeTag.clientWidth) / 2;
  
        this.$el.scrollTo({
          left: Math.max(targetScrollLeft, 0),
          behavior: 'auto',
        });
      });
    },
  });